/**
 * Bridge to host environment.
 *  - Inside Flutter WebView: uses window.FlutterChannel postMessage for haptics, balance refresh, close.
 *  - In a normal browser: stubs everything to no-ops.
 *  - Auth token: read from URL ?token= or from FlutterChannel.getAuthToken (async via callback).
 */

const params = new URLSearchParams(window.location.search);

export const config = {
  backendUrl: import.meta.env.VITE_BACKEND_URL || params.get('backend') || 'https://aclives-production.up.railway.app',
  socketUrl: import.meta.env.VITE_SOCKET_URL || params.get('socket') || null, // defaults to backendUrl
  initialToken: params.get('token') || null,
};

const isFlutter = typeof window.FlutterChannel !== 'undefined';

export function postFlutter(payload) {
  if (!isFlutter) return;
  try { window.FlutterChannel.postMessage(JSON.stringify(payload)); } catch (e) {}
}

export function haptic(kind = 'light') { postFlutter({ type: 'haptic', kind }); }
export function requestBalanceRefresh() { postFlutter({ type: 'balanceChanged' }); }
export function closeGame() { postFlutter({ type: 'close' }); }

let cachedToken = config.initialToken;
const tokenWaiters = [];

// Flutter calls this back when token is refreshed.
window.__setAuthToken = (token) => {
  cachedToken = token;
  while (tokenWaiters.length) tokenWaiters.shift()(token);
};

export async function getAuthToken() {
  if (cachedToken) return cachedToken;
  if (!isFlutter) return null;
  postFlutter({ type: 'requestAuthToken' });
  return new Promise((resolve) => {
    const t = setTimeout(() => resolve(null), 4000);
    tokenWaiters.push((tok) => { clearTimeout(t); resolve(tok); });
  });
}

export const isInFlutter = isFlutter;
